import { Alert, Spin, Select, Row, Col } from "antd";
import CardPage from "../../../layout/CardPage";
import { StatusCard } from "./components/StatusCard";
import { useSemaforoData } from "./hooks/useSemaforoData";
import "./semaforo.css";

export const SemaforoConcesionarios = () => {
  const { loading, error, asesorSeleccionado, setAsesorSeleccionado, asesores, agrupados } =
    useSemaforoData();

  const opcionesAsesor = [
    { label: "Todos", value: "Todos" },
    ...asesores.map((asesor) => ({ label: asesor, value: asesor })),
  ];

  return (
    <div style={{ marginBottom: 15 }}>
      <Row>
        <Col span={12} className="card__titulo_container">
          <div className="card__titulo">Semáforo Concesionados</div>
        </Col>
        <Col span={12} style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", paddingRight: 20 }}>
          <Select
            value={asesorSeleccionado}
            onChange={(value) => setAsesorSeleccionado(value)}
            options={opcionesAsesor}
            style={{ width: 300 }}
            placeholder="Selecciona un asesor"
          />
        </Col>
      </Row>

      <div className="card__contenido">
        {loading && (
          <div style={{ textAlign: "center", paddingTop: 50 }}>
            <Spin size="large" tip="Cargando semáforo..." />
          </div>
        )}

        {error && !loading && (
          <Alert
            message="Error"
            description={error}
            type="error"
            showIcon
            style={{ marginBottom: 10 }}
          />
        )}

        {!loading && !error && (
          <div className="semaforo-dinamico__grid">
            {agrupados.map((grupo) => (
              <StatusCard
                key={grupo.estatusId}
                nombre={grupo.nombre}
                servicios={grupo.servicios}
                reglas={grupo.reglas}
                total={grupo.total}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};
